// Holds the singleton MSAL PublicClientApplication instance so non-React modules
// (notably the global fetch interceptor) can perform a silent token refresh when
// a stored access token has expired — without waiting for a React render cycle.
// Set once from index.js right after the instance is created.

let _instance = null;

export function setMsalInstance(instance) {
  _instance = instance;
}

export function getMsalInstance() {
  return _instance;
}

// The access token issued by the interactive login itself (captured from the
// MSAL LOGIN_SUCCESS / ACQUIRE_TOKEN_SUCCESS event). completeAuth uses this as a
// fallback so a silent-acquisition failure right after login does not force a
// second interactive sign-in when we already hold a valid token.
let _lastLoginToken = null;

export function setLastLoginToken(token) {
  _lastLoginToken = token;
}

export function getLastLoginToken() {
  return _lastLoginToken;
}

// Set (in sessionStorage) when the platform refuses the account Microsoft signed
// in. Microsoft keeps a session for that account, so a plain sign-in would
// silently pick it again and loop. While this flag is set, the next sign-in asks
// Microsoft to show its sign-in screen (prompt=login) so another account can be
// used. Consumed by whichever sign-in button is clicked next.
export const FORCE_SIGNIN_PROMPT_KEY = 'cp.forceSignInPrompt';

// Returns { prompt: 'login' } once if a refusal was recorded, then clears it.
export function consumeForcedSignInPrompt() {
  try {
    if (sessionStorage.getItem(FORCE_SIGNIN_PROMPT_KEY)) {
      sessionStorage.removeItem(FORCE_SIGNIN_PROMPT_KEY);
      return { prompt: 'login' };
    }
  } catch (_) { /* storage unavailable: fall back to a normal sign-in */ }
  return {};
}
